import './blogs.scss'
export const Blog = () => {
    return (
        <div>
            This is blogs page.

            <div id="back_voilet">
                <div id='voilet_child'>
                    <h1>How to Promote Your Small Business Blog</h1>
                    <p>Over 20 ways to increase traffic to your blog.</p>
                </div>
            </div>

            <div>
                <div className='first_big , all_width'>
                    <p>
                        You started your small business blog for a reason. Maybe your goal is to grow your business, improve relationships with existing customers, increase awareness of your products or services, or all 3.

                        The key to achieving these goals is connecting to the right audience. Luckily, there are lots of ways to promote your posts. The perfect promotion strategy will look different for every business, so don’t be afraid to try out different tactics until you find a good fit.
                    </p>
                </div>
                <div className='first_big , all_width'>
                    <h1 className='big_font'>
                        Drive visits from search
                    </h1>
                    <p className='margin_bottom'>
                        Search engines like Google rank their results based on how well the content matches the search query. There are a few ways you can improve your rankings and attract new visitors.
                    </p>

                    <h3 className='mid_small_font'>
                        Prioritize search engine optimization (SEO)
                    </h3>
                    <p>SEO is a complex topic, but can be boiled down to a few steps:</p>
                    <li>Write your blog post with a single search query in mind</li>
                    <li>Include the search query in the URL and title tag of your blog post</li>
                    <li>Write a compelling meta description</li>
                    <p className='margin_bottom'>
                        Need a more in-depth explanation of SEO? Read more about how to optimize your posts for search engines.
                    </p>
                </div>
                <div className='all_width' >
                    <h1 className='mid_small_font'>Include a link to your blog within your main site navigation</h1>
                    <p className='margin_bottom'>Most websites have a menu at the top of the page which allows visitors to quickly get to different sections of the site. For example, on the Mailchimp site, there’s a link to Resources in the main menu and a dropdown menu for subsections like Marketing Tips.
                        <br />
                        Make sure you’ve included a link to your blog on the main navigation in a similar way. This makes it easy for visitors to navigate to the section of the site that most interests them, and it’s good for search too. Search engines use these links a lot like human visitors do—in order to discover the content on your site.</p>
                </div>

                <div>
                    <div className='all_width'>
                        <h1 className='big_font'>Drive visits from social media</h1>
                        <p>
                            If your customer base is active on 1 or more social media sites, there are lots of things you can do to drive traffic from those sites.
                        </p>
                    </div>

                    <div className='all_width'>
                        <h3 className='mid_small_font'>Optimize your blog posts for social media</h3>
                        <p>
                            Several elements determine how your content appears when it’s shared on social media sites. By optimizing these elements, you’ll make your posts more visually appealing and increase the likelihood of attracting visits from these sites.

                            <br /> <br />
                            The Open Graph protocol is used by a number of social media sites including Facebook, LinkedIn, and Pinterest. Twitter uses some open graph elements, but also has a separate set of elements called Twitter card tags which determine how your content appears when it is shared.

                            Your strategy depends on which social media sites your audience uses. The easiest way to implement these tags is by using a plugin, which is a downloadable software add-on. Many plugins are free and compatible with Google Chrome. If you’re confident when it comes to coding, you can also implement these tags directly on your blog posts by adding the relevant tags to the .
                        </p>
                    </div>

                    <div className='all_width'>
                        <h3 className='mid_small_font'>Share your posts on social media</h3>
                        <p >
                            Sharing your own blog posts is a great way to attract readers. You could do this via your own personal profiles (if appropriate) in addition to sharing via your company profiles.

                            <br /><br />

                            Experiment with the timing—you can play around with both the time of day that you post and how many times you share. Think about how people use a specific social network. For example, Twitter feeds tend to be pretty busy, and sharing a blog post just once here might mean it’s unlikely to be seen. You might elect to share each post a couple of times, at different times, or on various days.
                        </p>
                    </div>

                    <div className='all_width'>
                        <h3 className='big_font'>
                            Drive visits to your blog via email
                        </h3>
                        <p>
                            Email is a powerful marketing tool, and there are a number of ways you can use it to promote your blog posts.
                            <br /> <br />
                            You can create an email list specifically to notify your blog readers when you publish new posts, or include links to your posts in an email newsletter which you already produce.
                            <br /> <br />
                            You can also include relevant links to blog posts in automated emails you’ve already set up for your business. For example, automated welcome emails and order confirmation emails are great places to link to your blog content.
                            <br /> <br />
                            Another option to consider is including a link to your small business blog, or to a specific blog post if that’s more appropriate, in your email signature. That way you can easily promote your posts in your everyday communication.
                        </p>
                    </div>
                </div>

            </div>

            <div id="footer">
                <div id="footer_inside">
                    <div>
                        <h3>Projects</h3>
                        <p class="small_font">Why Mailchimp</p>
                        <p class="small_font">Product updates</p>
                        <p class="small_font">Email Marketing</p>
                        <p class="small_font">Website</p>
                    </div>
                    <div>
                        <h3>
                            Resources
                        </h3>
                        <p class="small_font">Guide and Tutorials</p>
                        <p class="small_font">Marketing Tips</p>
                        <p class="small_font">Free marketing tools</p>
                        <p class="small_font">Marketing Glossary</p>
                    </div>
                    <div>
                        <h3>Community</h3>
                        <p class="small_font">Agencies and Freelancers</p>
                        <p class="small_font">Developers</p>
                        <p class="small_font">Events</p>
                    </div>
                    <div>
                        <h3>Company</h3>
                        <p class="small_font">Our Stories</p>
                        <p class="small_font">NewsRooms</p>
                        <p class="small_font">Annual Reports</p>
                        <p class="small_font"></p>
                    </div>
                    <div>
                        <div>
                            <img src="https://eep.io/images/yzco4xsimv0y/73ZAoe8O3Y7SXQLeCNTq5u/8ddf1f63b4abdf7f67149d3a9d74a0bd/MCP.svg?w=260&fm=webp&q=80"
                                className='small_image' />
                            {/* style="width:150px" */}
                            <p class="small_font">Films, podcasts, and original series that celebrate the entrepreneurial spirit.</p>
                            <p class="small_font" style={{ marginBottom: "40px" }}>Check it out</p>
                        </div>
                        <div>
                            <img src="https://eep.io/images/yzco4xsimv0y/5itQmdXHB6vMuAcvyWp5MR/ef5cd2cecd4c92b7029a22ec67585c65/Courier.svg?w=260&fm=webp&q=80"
                                className='small_image' />
                            {/*  style="width:130px; margin-top: 50px;" */}
                            <p class="small_font">Expert insights, industry trends, and inspiring stories that help you live and work on
                                your own terms.</p>
                            <p class="small_font">Learn more</p>
                        </div>

                    </div>
                </div>

            </div>

        </div>
    )
}